import Button from '@mui/joy/Button'
import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'
import EventRepeatRoundedIcon from '@mui/icons-material/EventRepeatRounded'
import ConfirmationNumberRoundedIcon from '@mui/icons-material/ConfirmationNumberRounded'

export type CheckoutSuccessHeroSecondaryAction = {
    label: string
    href?: string
    onClick?: () => void
}

export default function CheckoutSuccessHero({
    imageSrc,
    imageAlt,
    title,
    text,
    actionHref,
    actionLabel,
    secondaryActions = [],
}: {
    imageSrc: string
    imageAlt: string
    title: string
    text: string
    actionHref: string
    actionLabel: string
    secondaryActions?: CheckoutSuccessHeroSecondaryAction[]
}) {
    return (
        <Box sx={{
            backgroundColor: 'common.white',
            borderRadius: '10px',
            boxShadow: '0 14px 40px rgba(15, 23, 42, 0.08)',
            overflow: 'hidden',
            position: 'relative',
            border: '1px solid rgba(15, 23, 42, 0.06)',
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                gap: 2,
                padding: {
                    xs: 3,
                    sm: 4,
                },
            }}>
                <Box
                    component="img"
                    src={imageSrc}
                    alt={imageAlt}
                    sx={{
                        width: '100%',
                        maxWidth: 240,
                        height: 'auto',
                    }}
                />
                <Typography
                    component="h1"
                    sx={{
                        color: '#111827',
                        fontWeight: 600,
                        fontSize: {
                            xs: '1.375rem',
                            md: '1.5rem',
                        },
                        lineHeight: 1.15,
                        maxWidth: 460,
                    }}
                >
                    {title}
                </Typography>
                <Typography
                    sx={{
                        color: '#4B5563',
                        fontSize: {
                            xs: '0.875rem',
                            sm: '1rem',
                        },
                        lineHeight: 1.6,
                        maxWidth: 600,
                    }}
                >
                    {text}
                </Typography>
                <Button
                    component="a"
                    href={actionHref}
                    sx={{
                        mt: 1,
                        minWidth: 240,
                        fontSize: '15px',
                        padding: '0.875rem 1.25rem',
                        borderRadius: '10px',
                        backgroundColor: '#111827',
                        width: {
                            xs: '100%',
                            sm: 'auto',
                        },
                    }}
                    startDecorator={<ConfirmationNumberRoundedIcon />}
                >
                    {actionLabel}
                </Button>
                {secondaryActions.length > 0 ? (
                    <Box sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                        gap: 1,
                    }}>
                        {secondaryActions.map(action => (
                            <Button
                                key={action.label}
                                component={action.href ? 'a' : 'button'}
                                href={action.href}
                                onClick={action.onClick}
                                variant="outlined"
                                sx={{
                                    fontSize: '15px',
                                    padding: '0.75rem 1rem',
                                    borderRadius: '10px',
                                    width: {
                                        xs: '100%',
                                        sm: 'auto',
                                    },
                                }}
                                startDecorator={<EventRepeatRoundedIcon />}
                            >
                                {action.label}
                            </Button>
                        ))}
                    </Box>
                ) : null}
            </Box>
        </Box>
    )
}
